'use client';

import { createContext, useContext, useState, useCallback, type ReactNode, useEffect } from 'react';

interface MFAContextType {
  showMFAModal: boolean;
  openMFAModal: () => void;
  closeMFAModal: () => void;
}

const MFAContext = createContext<MFAContextType | undefined>(undefined);

export const MFAProvider = ({ children }: { children: ReactNode }) => {
  const [showMFAModal, setShowMFAModal] = useState(false);

  useEffect(() => {
    // Disable the old MFA logout modal
    // MFA setup is now handled in the login flow
    setShowMFAModal(false);
  }, []);

  const openMFAModal = useCallback(() => {
    setShowMFAModal(true);
  }, []);

  const closeMFAModal = useCallback(() => {
    // MFA modal cannot be closed normally, but we provide this for completeness
    setShowMFAModal(false);
  }, []);

  return <MFAContext.Provider value={{ showMFAModal, openMFAModal, closeMFAModal }}>{children}</MFAContext.Provider>;
};

export const useMFA = () => {
  const context = useContext(MFAContext);
  if (!context) {
    throw new Error('useMFA must be used within MFAProvider');
  }
  return context;
};
